import api from './client'

export const pagosApi = {
  listar: (params) => api.get('/pagos', { params }),
  crear: (data) => api.post('/pagos', data),
  obtener: (id) => api.get(`/pagos/${id}`),
  actualizar: (id, data) => api.put(`/pagos/${id}`, data),
  imputar: (id, imputaciones) => api.post(`/pagos/${id}/imputar`, { imputaciones }),
  // Cliente de un recibo A CUENTA (si ya está en Presea, solo la ficha que tiene Presea)
  cambiarCliente: (id, clienteId) => api.post(`/pagos/${id}/cliente`, { cliente_id: clienteId }),
  confirmar: (id, motivo) => api.post(`/pagos/${id}/confirmar`, { motivo }),
  enviarPresea: (id) => api.post(`/pagos/${id}/enviar-presea`),
  anular: (id, motivo) => api.post(`/pagos/${id}/anular`, { motivo }),
  rechazar: (id, motivo) => api.post(`/pagos/${id}/rechazar`, { motivo }),
  devueltoEnPasarela: (id) => api.post(`/pagos/${id}/devuelto-en-pasarela`),
  devolucion: (id, data) => api.post(`/pagos/${id}/devolucion`, data),
}

/** Recibo hecho EN PRESEA, importado a LGR (retenciones).
 *  ref = { nv_id } (queda imputado a esa NV) o { cliente_id } (recibo libre, a cuenta). */
export const recibosPreseaApi = {
  verificar: (ref, numero) => api.post('/recibos-presea/verificar', { ...ref, numero }),
  importar: (ref, numero, formulario) =>
    api.post('/recibos-presea/importar', { ...ref, numero, formulario }),
}

export const mediosPagoApi = {
  listar: (soloActivos = false) =>
    api.get('/medios-pago', { params: soloActivos ? { activos: true } : {} }),
}
